var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "m-0", attrs: { "no-body": "" } },
    [
      _c("b-card-body", [
        !_vm.editing
          ? _c("p", {
              staticClass: "note-description rich-text-editor--reset p-0",
              domProps: { innerHTML: _vm._s(_vm.noteDescriptionHTML) },
              on: {
                dblclick: function ($event) {
                  $event.preventDefault()
                  return _vm.editNote.apply(null, arguments)
                },
              },
            })
          : _c(
              "div",
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.noteDescription,
                      expression: "noteDescription",
                    },
                  ],
                  ref: "textarea",
                  staticClass:
                    "w-100 editable-note rich-text-editor--reset p-0",
                  attrs: { id: "add-description-" + _vm.labelValue },
                  domProps: { value: _vm.noteDescription },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.noteDescription = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "d-none",
                    attrs: { for: "add-description-" + _vm.labelValue },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.actions.enterDescription")))]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "d-none",
                    attrs: { for: "foreColorPicker-" + _vm.labelValue },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.words.color")))]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "d-none",
                    attrs: { for: "backColorPicker-" + _vm.labelValue },
                  },
                  [_vm._v(_vm._s(_vm.$t("global.words.color")))]
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "justify-content-end pb-2" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "px-3", attrs: { cols: "12" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "float-right add-list mt-3",
                            attrs: {
                              variant: "primary",
                              size: "sm",
                              disabled: !_vm.canSave,
                            },
                            on: { click: _vm.handleEdit },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.actions.saveChanges")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c(
        "b-card-footer",
        [
          _c("timeline-card-footer", {
            attrs: { pinned: _vm.pinned },
            on: {
              pinned: function ($event) {
                return _vm.handlePin(_vm.id, _vm.activityType, _vm.pinned)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c(
                      "b-col",
                      {
                        staticClass: "vertical-center mb-md-0 mb-2",
                        attrs: { cols: "12", md: "auto" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "vertical-center" },
                          [
                            _c(
                              "profile-avatar",
                              _vm._b(
                                {
                                  staticClass:
                                    "client-profile-owner-avatar mr-2",
                                  attrs: { "avatar-options": { inline: true } },
                                },
                                "profile-avatar",
                                _vm.creator,
                                false
                              )
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "mr-1" }, [
                              _vm._v(_vm._s(_vm.name)),
                            ]),
                            _vm._v(" "),
                            _vm.notUpdatedYet
                              ? _c("i18n", {
                                  staticClass: "text-lowercase",
                                  attrs: {
                                    path: "global.actions.hasCreatedA",
                                    tag: "span",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item",
                                        fn: function () {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-secondary bold",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "global.words.note",
                                                        1
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2812711582
                                  ),
                                })
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("global.words.updated")) +
                                      "\n              "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "text-secondary bold" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$tc("global.words.note", 1)
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "vertical-center mb-md-0 mb-2",
                        attrs: { cols: "12", md: "auto" },
                      },
                      [
                        _c("span", { staticClass: "px-2 d-none d-md-inline" }, [
                          _vm._v("-"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("momentLocal")(
                                  _vm.updatedAt,
                                  "MMM. DD, YYYY"
                                )
                              ) +
                              " @\n            " +
                              _vm._s(
                                _vm._f("momentLocal")(_vm.updatedAt, "LT")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.right",
                                value: {
                                  title: _vm.$t(
                                    "client-profile.actions.createActivity"
                                  ),
                                },
                                expression:
                                  "{\n              title: $t('client-profile.actions.createActivity')\n            }",
                                modifiers: { right: true },
                              },
                            ],
                            ref: "tooltipAnchor",
                            staticClass: "clickable ml-3 convert-icon",
                            on: { click: _vm.openActivityConvertModal },
                          },
                          [
                            _c("icon", {
                              attrs: {
                                name: "calendar-plus-o",
                                "aria-hidden": "true",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex flex-row align-items-center justify-content-end justify-content-md-start",
                        attrs: { col: "", md: "auto" },
                      },
                      [
                        _c("div", { staticClass: "dropleft ml-3" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "grey-text text-darken-4 clickable vertical-center",
                              class: { disabled: _vm.disabledActions },
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("more_vert"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "clickable dropdown-item text-primary edit-note",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.editNote.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("client-profile.actions.editNote")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-divider" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(
                                  "inline-prompt",
                                  {
                                    attrs: {
                                      placement: "left",
                                      "confirmation-text": _vm.$t(
                                        "client-profile.messages.deleteConfirmation",
                                        {
                                          item: _vm.$t("global.words.note"),
                                        }
                                      ),
                                    },
                                    on: { accept: _vm.handleDelete },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "clickable dropdown-item text-danger btn-danger remove-note",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "client-profile.actions.deleteNote"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }